import {isEmpty} from "../helpers/helpers";

export const initial_state = {
    properties: [],
    total: 0,
    load_more: {
        page: 1,
        loading: false,
        has_more: true,
    },
    last_route: '',
    pushState: {
        link: '',
        href: '',
        loading: false,
        offsetTop: 0,
        media: 0,
        back: false,
        isBadeSaba: false,
    }
};

export const PropertiesReducer = (state, action) => {
    let has_more = true;

    switch (action.type) {
        case 'ADD_NEW':
            has_more = (!isEmpty(action.payload) && !isEmpty(action.payload.properties) && (action.payload.properties.length * (action.page - 1)) < action.payload.total);
            return {
                ...state,
                properties: action.payload.properties,
                total: action.payload.total,
                load_more: {
                    page: action.page,
                    loading: false,
                    has_more: has_more,
                },
                last_route: action.payload.last_route,
                list_page: action.list_page ?? 'search'
            };
        case 'ADD_PREV':
            has_more = (!isEmpty(action.payload) && !isEmpty(action.payload.properties) && (action.payload.properties.length * action.page) < action.payload.total);

            return {
                ...state,
                properties: [...state.properties, ...action.payload.properties],
                total: action.payload.total,
                load_more: {
                    page: action.page,
                    loading: false,
                    has_more: has_more,
                },
                last_route: action.payload.last_route
            };
        case 'LOAD_MORE':
            return {
                ...state,
                load_more: action.payload
            };

        case 'PUSH_STATE':
            return {
                ...state,
                pushState: {
                    link: action.payload.link ?? state.pushState.link,
                    href: action.payload.href ?? state.pushState.href,
                    loading: action.payload.loading ?? state.pushState.loading,
                    offsetTop: action.payload.offsetTop ?? state.pushState.offsetTop,
                    media: action.payload.media ?? state.pushState.media,
                    back: action.payload.back ?? state.pushState.back,
                    isBadeSaba: action.payload.isBadeSaba ?? state.pushState.isBadeSaba,
                },
            };
    }
};

